//==============================================
// App Scripts
//==============================================


import * as team from './modules/archive/team-table.js';
import * as audio from './modules/components/audio-player.js';

(function ($) {
    
    $( () => {

        team.tableSelect();
        team.dataTables();
        audio.audioPlayer();
    

    });

})(jQuery);